import React from '@root/vendor/react';

const ProjectContext = React.createContext({});

export default ProjectContext;
